
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { ProfileFormProps } from "./types";
import { ProfileHeaderSection } from "./ProfileHeaderSection";
import { ProfileTabs } from "./ProfileTabs";
import { ProfileSharing } from "./ProfileSharing";

export const ProfileForm = ({ 
  register, 
  profile, 
  isLoading,
  onSubmit,
  onUpload,
  watch,
  setValue
}: ProfileFormProps) => {
  return (
    <form onSubmit={(e) => {
      // Prevent default form submission when clicking buttons inside the form
      // that are not explicitly type="submit"
      if (e.target && (e.target as HTMLElement).tagName === 'FORM') {
        onSubmit(e);
      }
    }} className="space-y-6">
      <ProfileHeaderSection profile={profile} onUpload={onUpload} />
      <ProfileTabs 
        profile={profile} 
        register={register}
        watch={watch}
        setValue={setValue}
      />

      <div className="flex justify-between gap-4">
        <ProfileSharing username={profile.username || profile.id} />
        
        <Button type="submit" disabled={isLoading}>
          {isLoading ? (
            "Saving..."
          ) : (
            <>
              <Save className="w-4 h-4 mr-2" />
              Save Changes
            </>
          )}
        </Button>
      </div>
    </form>
  );
};
